import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: 'Do I need experience?',
    a: 'Not at all. This is designed for complete beginners and those who have tried and failed.'
  }, {
    q: 'Is resin toxic?',
    a: 'We teach you proper safety protocols and recommend non-toxic, home-safe resin brands.'
  }, {
    q: 'How much do materials cost?',
    a: 'You can get started with a basic kit for under $50. We provide a shopping list.'
  }, {
    q: 'Do I need a workshop?',
    a: 'No. You can do this on a kitchen table with our clean-workspace method.'
  }, {
    q: 'What if I already failed before?',
    a: "That's exactly who this is for. We identify why you failed and fix it."
  }, {
    q: 'How long do I get access?',
    a: 'Forever. You get lifetime access to the course and all future updates.'
  }];
  return <section className="py-20 bg-white" data-id="element-14">
      <div className="container mx-auto px-4 max-w-2xl" data-id="element-15">
        <h2 className="text-3xl font-bold text-stone-900 mb-10 text-center" data-id="element-16">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4" data-id="element-17">
          {faqs.map((faq, idx) => <FaqItem key={idx} question={faq.q} answer={faq.a} data-id="element-18" />)}
        </div>
      </div>
    </section>;
}
function FaqItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-stone-200 rounded-lg overflow-hidden" data-id="element-19">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-5 text-left bg-white hover:bg-stone-50 transition-colors" data-id="element-20">
        <span className="font-bold text-stone-800" data-id="element-21">{question}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-stone-400" data-id="element-22" /> : <ChevronDown className="w-5 h-5 text-stone-400" data-id="element-23" />}
      </button>
      {isOpen && <div className="p-5 pt-0 bg-stone-50 text-stone-600 border-t border-stone-100" data-id="element-24">
          {answer}
        </div>}
    </div>;
}